export default __webpack_public_path__ + "static/media/hh14.bb9a2a25.png";